import React from 'react';
import { useSelector } from 'react-redux';

import { Section } from 'features/order-tracker/shared-components';
import { useTodaysOpenreachAppointmentManager } from 'features/order-tracker/store/hooks/useTodaysOpenreachAppointmentManager';
import { getAppointmentsInfo } from 'features/order-tracker/store/selectors';

import {
  BackToOrdersLink,
  SnapshotCardContent,
  SnapshotCardHeader,
  Tabs,
  TodaysEngineerAppointmentInfo,
} from './components';
import { ENGINEER_VISIT_TITLE, ORDER_STATUS_TITLE } from './constants';

import styles from './styles.module.scss';

export const SnapshotCardSection: React.FC = () => {
  const { engineerAppointments } = useSelector(getAppointmentsInfo);
  const [apptUserPathStep, setNextStep] = useTodaysOpenreachAppointmentManager(engineerAppointments);

  let content = (
    <>
      <SnapshotCardHeader />
      <SnapshotCardContent />
    </>
  );

  if (apptUserPathStep !== null) {
    content = (
      <Tabs
        tabs={[
          {
            title: ORDER_STATUS_TITLE,
            content: (
              <>
                <SnapshotCardHeader />
                <SnapshotCardContent />
              </>
            ),
          },
          {
            title: ENGINEER_VISIT_TITLE,
            content: <TodaysEngineerAppointmentInfo step={apptUserPathStep} setNextStep={setNextStep} />,
          },
        ]}
        renderDependencies={[apptUserPathStep]}
      />
    );
  }

  return (
    <Section className={styles.snapshotCardSection}>
      <BackToOrdersLink />
      <div className={styles.container}>{content}</div>
    </Section>
  );
};
